(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[346],{

/***/ 90346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70539);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40050);
/* harmony import */ var _custom_Highlight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(958);
/* harmony import */ var _custom_Staff__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33528);
/* harmony import */ var _components_ContactForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64150);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61137);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34495);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79697);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(117);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);


















var Contact = function(param) {
    var title = param.title, description = param.description, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, _buying = param.buying, buying = _buying === void 0 ? true : _buying, _separator = param.separator, separator = _separator === void 0 ? true : _separator, staff = param.staff, _leftLabel = param.leftLabel, leftLabel = _leftLabel === void 0 ? true : _leftLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sectionRef = param.sectionRef, route = param.route, translations = param.translations;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__/* .useResponsive */ .F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile;
    var isGeneral = variant.includes("general");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    if (loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            sectionRef: sectionRef,
            separator: separator,
            variant: [
                variant.includes("gray") ? "gray" : "white"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: [
                        isTablet ? "-align-center" : "-distribute-between"
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 7 : 6,
                            children: [
                                leftLabel && staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__/* .withModifiers */ .i)("intro", [
                                        isGeneral && "general",
                                        !leftLabel && "offset-top"
                                    ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default())),
                                    children: leftLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            " ",
                                            translations.interestedIn[router.locale],
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                variant: [
                                                    "accent",
                                                    "font-primary"
                                                ],
                                                children: translations.buying[router.locale]
                                            }),
                                            " ",
                                            translations.property[router.locale]
                                        ]
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && staff.map(function(person, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Staff__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                            width: isSmallMobile && 168,
                                            height: isSmallMobile && 308,
                                            variant: [
                                                "inline",
                                                "align-middle"
                                            ]
                                        }, person), {
                                            job: person.job[router.locale]
                                        }), "contact-staff-".concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 11 : 6,
                            children: [
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().description),
                                    children: description
                                }),
                                isGeneral || title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                    children: title || translations.assistance[router.locale]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_9___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().intro), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().last)),
                                    children: [
                                        translations.interestedIn[router.locale],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            variant: [
                                                "font-primary",
                                                buying && "accent"
                                            ],
                                            children: buying ? translations.buying[router.locale] : translations.renting[router.locale]
                                        }),
                                        translations.thisProperty[router.locale]
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactForm__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    route: route,
                                    translations: translations,
                                    disabled: disabled
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 61137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__R0Yt_","intro":"styles_intro__e1Is4","contact":"styles_contact___xZ2x","last":"styles_last__LjZl_","intro--general":"styles_intro--general__85IDi","intro--offset-top":"styles_intro--offset-top__l7dZT","title":"styles_title__HCVSt","description":"styles_description__T7k67","staff":"styles_staff__gQuG0","name":"styles_name__nWG3U","position":"styles_position__RkAOQ","label":"styles_label___1bq_","button":"styles_button__nXKqX","position--general":"styles_position--general__OycEg"};

/***/ })

}]);